import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ExtractBlogInstructionsFromPdf($sectionId: ID!, $documentId: ID!, $projectId: ID) {
    extractBlogInstructionsFromPdf(
      sectionId: $sectionId
      documentId: $documentId
      projectId: $projectId
    ) {
      instructions
      status
      extractionErrors
    }
  }
`;

interface Result {
  instructions: string;
  status: string;
  extractionErrors: string[] | null;
}

export const extractBlogInstructionsBasedOnPdf = async (
  sectionId: ID,
  documentId: ID,
  projectId: ID
) => {
  const variables = { sectionId, documentId, projectId };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });

  return getSingleProp<Result>(result.data);
};
